var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eco-content-space h100"},[_c('div',{staticClass:"employee-cards h100"},[_c('div',{staticClass:"eco-content-scroll relative"},[_c('trial-wizard',{attrs:{"agencyId":_vm.agencyId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }